"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariableName = void 0;
var VariableName;
(function (VariableName) {
    VariableName["acceleration"] = "acceleration";
    VariableName["alarmState"] = "alarmState";
    VariableName["angularVelocity"] = "angularVelocity";
    VariableName["assetUtilization"] = "assetUtilization";
    VariableName["battery"] = "battery";
    VariableName["buildingModel"] = "buildingModel";
    VariableName["carbonDioxide"] = "carbonDioxide";
    VariableName["costSekPerDay"] = "costSekPerDay";
    VariableName["counter"] = "counter";
    VariableName["cstats"] = "cstats";
    VariableName["currentL"] = "currentL";
    VariableName["distance"] = "distance";
    VariableName["dmdTotalPower"] = "dmdTotalPower";
    VariableName["dmdVoltageLtoNSum"] = "dmdVoltageLtoNSum";
    VariableName["egoneBootRecord"] = "egoneBootRecord";
    VariableName["electricalPower"] = "electricalPower";
    VariableName["elementCount"] = "elementCount";
    VariableName["extendedEnergySample"] = "extendedEnergySample";
    VariableName["fileRemoveLog"] = "fileRemoveLog";
    VariableName["force"] = "force";
    VariableName["heartRate"] = "heartRate";
    VariableName["heartRatePeriod"] = "heartRatePeriod";
    VariableName["heartRateRecievePower"] = "heartRateRecievePower";
    VariableName["illuminance"] = "illuminance";
    VariableName["image"] = "image";
    VariableName["imageSnapshotPresent"] = "imageSnapshotPresent";
    VariableName["lampIntensity"] = "lampIntensity";
    VariableName["lineFrequency"] = "lineFrequency";
    VariableName["linkUplog"] = "linkUplog";
    VariableName["log"] = "log";
    VariableName["logSniffer"] = "logSniffer";
    VariableName["motion"] = "motion";
    VariableName["onOffInput"] = "onOffInput";
    VariableName["onOffOutput"] = "onOffOutput";
    VariableName["onOffTransition"] = "onOffTransition";
    VariableName["openClosed"] = "openClosed";
    VariableName["operatingHours"] = "operatingHours";
    VariableName["particulateMatter"] = "particulateMatter";
    VariableName["peopleCount"] = "peopleCount";
    VariableName["percentage"] = "percentage";
    VariableName["positionLog"] = "positionLog";
    VariableName["present"] = "present";
    VariableName["pressure"] = "pressure";
    VariableName["pressureValue"] = "pressureValue";
    VariableName["pulseBand"] = "pulseBand";
    VariableName["pulseBandId"] = "pulseBandId";
    VariableName["pulseBandType"] = "pulseBandType";
    VariableName["qstatistics"] = "qstatistics";
    VariableName["rainLast24Hour"] = "rainLast24Hour";
    VariableName["rainLastHour"] = "rainLastHour";
    VariableName["rainRate"] = "rainRate";
    VariableName["rawMessagesRx"] = "rawMessagesRx";
    VariableName["rawMessagesTx"] = "rawMessagesTx";
    VariableName["refillList"] = "refillList";
    VariableName["relativeHumidity"] = "relativeHumidity";
    VariableName["sampleStatistics"] = "sampleStatistics";
    VariableName["siteOnlineStatus"] = "siteOnlineStatus";
    VariableName["slotAggregateValue"] = "slotAggregateValue";
    VariableName["slotAverageValue"] = "slotAverageValue";
    VariableName["slotMaxValue"] = "slotMaxValue";
    VariableName["slotMaxValueTime"] = "slotMaxValueTime";
    VariableName["slotMinValue"] = "slotMinValue";
    VariableName["slotMinValueTime"] = "slotMinValueTime";
    VariableName["slotNumberValues"] = "slotNumberValues";
    VariableName["soundBackground"] = "soundBackground";
    VariableName["soundEvents"] = "soundEvents";
    VariableName["soundPressureLevel"] = "soundPressureLevel";
    VariableName["statistics"] = "statistics";
    VariableName["temperature"] = "temperature";
    VariableName["temperatureC"] = "temperatureC";
    VariableName["temperatureF"] = "temperatureF";
    VariableName["temperatureK"] = "temperatureK";
    VariableName["timeBucket"] = "timeBucket";
    VariableName["timeDraining"] = "timeDraining";
    VariableName["timeDuration"] = "timeDuration";
    VariableName["timeEpoch"] = "timeEpoch";
    VariableName["totalApparentEnergy"] = "totalApparentEnergy";
    VariableName["totalenergy"] = "totalenergy";
    VariableName["totalpower"] = "totalpower";
    VariableName["totalpowerInst"] = "totalpowerInst";
    VariableName["undefined"] = "undefined";
    VariableName["unitState"] = "unitState";
    VariableName["uplog"] = "uplog";
    VariableName["upsState"] = "upsState";
    VariableName["videoBandwith"] = "videoBandwith";
    VariableName["videoFilePresent"] = "videoFilePresent";
    VariableName["volatileOrganicCompound"] = "volatileOrganicCompound";
    VariableName["volt"] = "volt";
    VariableName["voltageL"] = "voltageL";
    VariableName["voltageLtoNSum"] = "voltageLtoNSum";
    VariableName["wattsL"] = "wattsL";
    VariableName["weight"] = "weight";
    VariableName["windDirection"] = "windDirection";
    VariableName["windSpeedAvg"] = "windSpeedAvg";
    VariableName["windSpeedGust"] = "windSpeedGust";
})(VariableName = exports.VariableName || (exports.VariableName = {}));
//# sourceMappingURL=VariableName.js.map